import type { Ref } from "vue";
import { watchIgnorable, debounceFilter } from "@vueuse/core";

export const useDebouncedSearchQuery = (searchQuery: Ref<string>, search: () => unknown, debounce = 300) => {
  const { ignoreUpdates, ignorePrevAsyncUpdates } = watchIgnorable(searchQuery, () => search(), {
    eventFilter: debounceFilter(debounce),
  });

  const setSearchQuery = (value: string) => {
    ignorePrevAsyncUpdates();
    ignoreUpdates(() => {
      searchQuery.value = value;
    });
  };

  const resetSearchQuery = () => setSearchQuery("");

  return { resetSearchQuery, setSearchQuery };
};
